
const alertButtonTypes = {
  PRIMARY: 1,
  SUCCESS: 2,
  INFO: 3,
  WARNING: 4,
  DANGER: 5,
  GREY: 6
};

export default alertButtonTypes;



// WEBPACK FOOTER //
// ./src/consts/alertButtonTypes.js